import { Mapping } from '@atlaskit/editor-prosemirror/transform';
import type { Transform } from '@atlaskit/editor-prosemirror/transform';

/**
 * The doc range each step in `appliedTr` touches, expressed in `appliedTr.docs[0]`
 * coordinates (i.e. the live doc the transform started from, before any of the
 * suggestion's tool calls were applied) rather than each step's own intermediate
 * doc. Steps are applied in sequence, so a later step's positions are only valid in
 * the doc produced by the steps before it — mapping back through the inverse of
 * those prior steps is what makes every range comparable against the live doc.
 */
export function getSuggestionStepRanges(appliedTr: Transform): Array<{ from: number; to: number }> {
	const ranges: Array<{ from: number; to: number }> = [];

	appliedTr.steps.forEach((step, i) => {
		let from = Infinity;
		let to = -Infinity;
		step.getMap().forEach((oldStart, oldEnd) => {
			from = Math.min(from, oldStart);
			to = Math.max(to, oldEnd);
		});
		if (from > to) {
			return;
		}

		// `Mapping.slice().invert()` would invert every map in the transform (not just the ones
		// in the slice's range) — `Mapping#invert` reads `maps.length` directly, ignoring the
		// `from`/`to` bounds `slice()` sets. Build a standalone mapping over just the prior steps
		// instead.
		const toLiveDoc = new Mapping(appliedTr.mapping.maps.slice(0, i)).invert();
		ranges.push({ from: toLiveDoc.map(from, -1), to: toLiveDoc.map(to, 1) });
	});

	return ranges;
}
